"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnnualCargoRangeDefinition {
    constructor(data, ranges) {
        this.rangeCode = data.rangeCode;
        const range = ranges.find((ran) => ran.rangeCode === data.rangeCode);
        if (range) {
            this.from = range.from;
            this.to = range.to;
        }
        this.min = data.min;
        this.percentage = data.percentage;
    }
    static fromObj(data, ranges) {
        return new AnnualCargoRangeDefinition(data, ranges);
    }
}
exports.default = AnnualCargoRangeDefinition;
//# sourceMappingURL=annualCargoRangeDefinition.class.js.map